import Link from "next/link"
import Image from "next/image"
import Linked from "public/assets/linkedin-small.svg"
import YouTube from "public/assets/youtube-small.svg"
import Facebook from "public/assets/fb-small.svg"
import Reddit from "public/assets/reddit-small.svg"

export default function SocialMediaBar({ type }) {
  const renderSocial = () => {
    switch (type) {
      case "primary":
        return (
          <>
            <Link target="_blank" href="https://www.linkedin.com/company/federal-news-network/">
              <Image src="/assets/linkedin.png" height="40" width="40" alt="LinkedIn Logo" />
            </Link>
            <Link target="_blank" href="https://www.youtube.com/@federalnewsnetwork">
              <Image src="/assets/youtube.png" height="40" width="40" alt="YouTube Logo" />
            </Link>
            <Link target="_blank" href="https://www.facebook.com/FedNewsNetwork">
              <Image src="/assets/facebook.png" height="40" width="40" alt="Facebook Logo" />
            </Link>
            <Link target="_blank" href="https://www.reddit.com/user/Federal-News-Network/">
              <Image src="/assets/reddit-logo.png" height="40" width="40" alt="Reddit Logo" />
            </Link>
          </>
        )
      case "secondary":
        return (
          <>
            <Link target="_blank" href="https://www.linkedin.com/company/federal-news-network/">
              <Linked
                className="text-gray-light hover:text-secondary transitional-all duration-300"
                height="26"
                width="26"
                alt="LinkedInLogo"
              />
            </Link>
            <Link target="_blank" href="https://www.youtube.com/@federalnewsnetwork">
              <YouTube
                className="text-gray-light hover:text-secondary transitional-all duration-300"
                height="26"
                width="26"
                alt="YouTubeLogo"
              />
            </Link>
            <Link target="_blank" href="https://www.facebook.com/FedNewsNetwork">
              <Facebook
                className="text-gray-light hover:text-secondary transitional-all duration-300"
                height="26"
                width="26"
                alt="FacebookLogo"
              />
            </Link>
            <Link target="_blank" href="https://www.reddit.com/user/Federal-News-Network/">
              <Reddit
                className="text-gray-light hover:text-secondary transitional-all duration-300"
                height="26"
                width="26"
                alt="RedditLogo"
              />
            </Link>
          </>
        )
      default:
        return <p>Pick a SocialMediaBar type</p>
    }
  }

  return <div className="flex gap-3 max-w-xs mx-auto md:mx-0 md:justify-normal justify-center">{renderSocial()}</div>
}
